import { fixMath } from "./fixMath";
import type { FeeTransformType } from "../zod/FeeTransformSchema";

export function applyFeeTransform(
    cost: number,
    transform: FeeTransformType,
) {
    const transformed = fixMath.add(
        fixMath.multiply(cost, fixMath.add(1, (transform.rate) ?? 0)),
        transform.flat ?? 0,
    );
    let shown = transformed;
    if (transform.min !== undefined && shown < transform.min) {
        shown = transform.min;
    }
    if (transform.max !== undefined && shown > transform.max) {
        shown = transform.max;
    }
    if (shown < 0) shown = 0;
    const isSubsidized = shown < cost;
    return {
        cost,
        shownFee: shown,
        isSubsidized,
        lossPerOrder: isSubsidized ? fixMath.subtract(cost, shown) : 0,
    };
}
